import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DeviceTable from "components/deviceTable";
import CleaningHistoryTable from "components/cleaningHistoryTable";
import { setCleaningHistory } from "store/slices/firebaseSlice";
import { collection, getDocs } from "firebase/firestore";
import { db } from "services/firebase";

function CleaningHistory() {
  const dispatch = useDispatch();
  const { clientId, cleaningHistoryData, deviceIds } = useSelector((state) => state.firebase);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    if (!clientId || !selectedDevice) return;

    const getCleaningHistory = async () => {
      const cleaningHistory = await getDocs(
        collection(db, "Results", clientId, "devices", selectedDevice, "cleaningHistory")
      );
      let data = [];
      for (const num of cleaningHistory.docs) {
        const result = num.data();
        if (result.date && result.date.toDate) {
          result.date = result.date.toDate().toLocaleString();
        }
        data = [...data, result];
      }
      dispatch(setCleaningHistory(data));
    };
    getCleaningHistory();
  }, [selectedDevice]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={2.4}>
            <DeviceTable
              clientId={clientId}
              deviceIds={deviceIds}
              selectedDevice={selectedDevice}
              onDeviceSelect={setSelectedDevice}
            />
          </Grid>

          {selectedDevice && (
            <Grid item xs={12} md={9}>
              <CleaningHistoryTable
                selectedDevice={selectedDevice}
                cleaningHistoryData={cleaningHistoryData}
              />
            </Grid>
          )}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CleaningHistory;
